import { UserProfileV1 } from '@cais-group/access-manager/domain/api'

export function getAttributeFromUserProfile(
  key: string,
  userProfile: UserProfileV1
): string | null {
  if (
    !userProfile ||
    !userProfile.attributes ||
    !userProfile.inheritedAttributes
  ) {
    return null
  }

  let value = userProfile.attributes[key] as string | null

  if (!value && userProfile.inheritedAttributes) {
    value = getInheritedAttributeFromUserProfile(key, userProfile)
  }

  return value ?? null
}

function getInheritedAttributeFromUserProfile(
  key: string,
  userProfile: UserProfileV1
): string | null {
  if (!userProfile || !userProfile.inheritedAttributes) {
    return null
  }
  const value = userProfile.inheritedAttributes.find(
    (attribute) => attribute.attributes[key]
  )?.attributes?.[key]
  return (value as string) ?? null
}
